const APP_CONFIG = {
    baseURL: 'https://admin.fiso.edu.vn/api',
    appURL: 'http://app.fiso.edu.vn/'
};

export default APP_CONFIG;


// WEBPACK FOOTER //
// ./src/app/app.config.ts